import React from 'react'

import './action-bar.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    space?: '70' | '80' | '90' | '100' | '200' | '300' | '400' | '500'
    spaceRow?: '60' | '70' | '80' | '90'
    align?: 'left' | 'right' | 'center'
    mAlign?: 'left' | 'right' | 'center'
    lAlign?: 'left' | 'right' | 'center'
    alignItems?: 'center' | 'top' | 'bottom' | 'baseline'
    mobileBlock?: boolean
    noWrap?: boolean
  }
>

const ActionBar = ({
  className,
  children,
  space = '100',
  spaceRow = '90',
  align = 'left',
  mAlign,
  lAlign,
  alignItems = 'center',
  mobileBlock = false,
  noWrap = false,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn(
      'ActionBar',
      {
        [`space-${space}`]: !!space,
        [`spaceRow-${spaceRow}`]: !!spaceRow,
        [`align-${align}`]: true,
        [`m-align-${mAlign}`]: !!mAlign,
        [`l-align-${lAlign}`]: !!lAlign,
        [`alignItems-${alignItems}`]: true,
        mobileBlock,
        noWrap,
      },
      className
    )}
  >
    {children}
  </div>
)

export default ActionBar
